import { axios } from '../../../axios';

const getAllConversationsApi = () => {
  return axios.get("/conversations")
}
const getMessagesApi = (id) => {
  return axios.get(`/conversations/${id}/messages`)
}

const createConversation = (data) => {
  return axios.post("/conversations", {"receiverId" : data}).then(response => {
    console.log(response)
  }).catch(error => {
    console.log(error)
  })
}

export {getMessagesApi, getAllConversationsApi, createConversation}